import React from "react";
import { Input } from "antd";


export default class InputText extends React.Component {

  constructor(props) {
    super(props);
    const { id, placeholder, value, max, onlyText } = props;
    this.state = { value: value, id: id, placeholder: placeholder, max: max, onlyText: onlyText === undefined ? false : onlyText };

    this.onChange = this.onChange.bind(this);

  }

  onChange = (event) => {
    
    if (!this.state.onlyText) {
      this.setState({ value: event.target.value });
      this.props.onChange(event)
    } else {
      const re = /^[ñíóáéú a-zA-Z\b]+$/;
      if (event.target.value === '' || re.test(event.target.value)) {
        this.setState({ value: event.target.value });
        this.props.onChange(event)
      }
    }
  };

  onBlur = (event) => {
    this.props.onChange(event, this.state);
  }

  render() {
    return (<Input allowClear id={this.state.id} maxLength={this.state.max} placeholder={this.state.placeholder} style={{ width: '100%' }} value={this.state.value} onChange={this.onChange} />);
  }
}